import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("AxStaticConfigModule")
export class AxStaticConfigModule implements AxInit {
    static GA4Enabled: boolean;
    skipAddedToCartPopup: boolean;
    skipSummary: boolean;

    AxInit(init: IAxStaticConfigInitData): void {
        AxStaticConfigModule.GA4Enabled = init.ga4Enabled;
        this.skipAddedToCartPopup = init.skipAddedToCartPopup;
        this.skipSummary = init.skipSummary;
    }
}

export interface IAxStaticConfigInitData {
    ga4Enabled: boolean;
    skipAddedToCartPopup: boolean;
    skipSummary: boolean;
}